import { fetchPlans } from "../Util/queries";
import { PLANS } from "../Reducers/plansReducer";
import { PlansList } from "../Model/paymentObjects";

export const getPlans = () => async (dispatch) => {
    try {
        const response = await fetchPlans();
        dispatch({
            type: PLANS,
            payload: new PlansList(response.data)
        });
    } catch (error) {
        console.error(error);
        dispatch({
            type: PLANS,
            payload: new PlansList([])
        });  
    }
}
